import React, { useEffect } from 'react'
import TopBar from '../Layouts/TopBar'
import { useState } from 'react'
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../Layouts/Footer';
import PopupVideo from '../Components/PopupVideo';
 

function LandingPage() {

    const [university, setUniversity] = useState([]);

    useEffect(() => {
        listUniversity();
    }, []);

    const listUniversity = () => {
        axios.get("https://go.vecos.us/reunice/API/v1/Universitys/getAll")
            .then(response => {

                setUniversity(response.data);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });
    }

    return (

        <>
            <TopBar />
            <main className='mt-5'>

                <div className="container">
                    <div className="row g-4">
                        {/* Main content START */}
                        <div className="col">
                            <div className="bg-mode p-4">
                                <div className=" d-sm-flex justify-content-between align-items-center mb-5">

                                    <h1 className="h4 ">List of universities 
                                        <span className="ms-2 badge bg-danger bg-opacity-10 text-danger"><b>{university && university.length}</b></span></h1>

                                    <div className="nav  px-4 px-lg-0">
                                        <div className="nav-item ">
                                            <form className="rounded position-relative">
                                                <input className="form-control ps-5 bg-light" type="search" placeholder="Search..." aria-label="Search" />
                                                <button className="btn bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y" type="submit"><i className="bi bi-search fs-5"> </i></button>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div className="position-relative pt-0 mt-3 mt-md-5">

                                    {university &&
                                        university.map((d, index) => {
                                            return (
                                                <>
                                                    <div className="card bg-transparent border-0" >
                                                        <div className="row g-3">
                                                            <div className="col">
                                                                < a href="/en">
                                                                    <img style={{ cursor: "pointer" }} className="rounded bg-light" src={d.logo} alt={university.acronym} /></a>
                                                            </div>
                                                            <div className="col-8">


                                                                <p className="badge bg-danger bg-opacity-10 text-danger mb-2 fw-bold">
List of researchers</p>

                                                                <Link to={"university/" + d.acronym} ><h5 className="btn-link stretched-link text-reset fw-bold"> {d.name} </h5>
                                                                </Link>  <div className="d-none d-sm-inline-block">
                                                                   
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr className="my-4" />
                                                </>

                                            )
                                        })}



                                </div>
                            </div>
                        </div>


                    </div>
                </div>

            </main >

            <PopupVideo />
            <Footer/>




        </>
    )
}

export default LandingPage